//const baseUrl = 'http://localhost:3012';
const baseUrl = 'https://linklistapi.jasonseck.com';
//const tourystaPlaceholderImage = 'https://tourysta.s3-us-west-2.amazonaws.com/tourystaPlaceholderImage.png';
//const mapboxToken = 'pk.eyJ1IjoiamFzb25zZWNrIiwiYSI6ImNqYnk4OW00ZTJ4emYzMnI2YnBnbmZuYjkifQ.qU7A0DRAWuPqfLTGwS4-XA';
export { baseUrl }
